import { Accordion, AccordionSummary, AccordionDetails, Badge, Box, Button, Grid, Typography, Chip, Divider, makeStyles } from "@material-ui/core";
import { ConfirmDialogTS } from "../../_AAA/components/ReactDialogTS";
import { ConfirmDialogPropsScroll, ConfirmDialogPropsSize } from "../../js/types";
import { HintBellLogSearchResItemHintbell } from "../../js/adapter/HintBellAdapter";
import { FullWidthTabs } from "../../_AAA/components/ReactTabs";
import { HintType } from "./consts";
import { NoResults } from "../../_AAA/components/ReactError";
import { MessageData, MessageSearch } from ".";
import { BulletinSearchResItemBulletin } from "../../js/adapter/BulletinAdapter";
import { useState } from "react";
import { SearchFileResItem } from "../../js/adapter/FilesAdapter";
import { ReactIconBtn } from "../../_AAA/components/ReactButton";
import { ExpandMoreRounded, MenuOpen, OpenInNewOutlined } from "@material-ui/icons";
import { CustomDate } from "../../utils/date/dateExtension";
import MultiFileUpload from "../../_AAA/components/MultiFileUpload";
import { linkURL } from "../../js/Domain";
import { PaginationActionsTS } from "../../_AAA/components/ReactPaginationTS";
import { ModalHintBellModalName as ModalName, messageSearchFields } from "./consts";
import SearchSettings from "./ModalHintBellSearchSettings";

const useStyles = makeStyles((theme) => ({
    outlined: {
        border: `1px solid ${theme.palette.grey[400]} !important`,
        "&.MuiChip-deletable:focus": {
            border: `1px solid ${theme.palette.grey[400]} !important`,
            boxShadow: "none",
        },
    },
}));

interface ModalHintBellModalState {
    [ModalName.SEARCH_SETTINGS]: false | HintType;
}
interface ModalHintBellProps {
    messageData: MessageData, // 通知頁面資料
    messageSearch: MessageSearch,// 查詢條件
    bulletinfileList: { [key: string]: SearchFileResItem[] }, // 公佈欄檔案列表
    onMessageRead: (message: BulletinSearchResItemBulletin | HintBellLogSearchResItemHintbell, type: HintType) => void,
    messageTypes: HintType[], // 小鈴鐺有什麽類型的訊息
    modalClose: () => void,
    handleChangePage: (nowPage: number, type: HintType) => void//通知列表切換頁面事件
    setMessageSearch: (type: HintType, message: MessageSearch[HintType]) => void;// 更新查詢條件
}

const ModalHintBell = (props: ModalHintBellProps) => {
    const {
        bulletinfileList,
        messageData,
        messageSearch,
        messageTypes,
        onMessageRead,
        modalClose,
        handleChangePage,
        setMessageSearch
    } = props;

    const [expandedContent, setExpandedContent] = useState<string | null>(null);

    //modal開關控制
    const [modalState, setModalState] = useState<ModalHintBellModalState>({
        [ModalName.SEARCH_SETTINGS]: false,
    })

    /** 設置modal開關 */
    const setModalOpen = (modalName: ModalName, open: false | HintType) => {
        setModalState(prev => ({
            ...prev,
            [modalName]: open
        }))
    };

    // 點擊鏈接按鈕
    const handleLinkClick = async (elem: HintBellLogSearchResItemHintbell) => {
        const remarkArr = elem.sps_remark.split("/")
        const new_window = window.open(window.location.origin + "/" + remarkArr[2] + "/" + remarkArr[3], "ESD", 'height=700,width=1000');
        if (new_window !== null) {
            new_window.sessionStorage.setItem("params", elem.json);
            new_window.sessionStorage.setItem("home_page", remarkArr[1]);
        }
    }

    //點擊Accordion事件
    const handleAccordionClick = (id: string, elem: BulletinSearchResItemBulletin | HintBellLogSearchResItemHintbell, type: HintType) => {
        if (expandedContent === id) {
            setExpandedContent(null);
        } else {
            setExpandedContent(id);
            onMessageRead(elem, type);
        }
    }

    const searchSettingsModalConfirm = (type: HintType, message: MessageSearch[HintType]) => {
        setMessageSearch(type, { ...message, page: 1 })
        setModalOpen(ModalName.SEARCH_SETTINGS, false)
    }

    const handleChipDelete = (key: string, type: HintType) => {
        const newSearch = { ...messageSearch[type], [key]: '', page: 1 }
        setMessageSearch(type, newSearch)
    }

    return (<><ConfirmDialogTS
        modalOpen={true}
        closeClick={() => modalClose()}
        modal={{
            id: "ModalHintBell",
            modaltitle: "通知",
            padding: "0px",
            size: ConfirmDialogPropsSize.MD,
            scroll: ConfirmDialogPropsScroll.BODY,
            modalBtnGroup:
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <Button
                        color="primary"
                        type="button"
                        onClick={modalClose}>
                        關閉
                    </Button>
                </Box>,
            messages:
                <FullWidthTabs
                    padding={"none"}
                    boxMinHeight={"none"}
                    tabsData={
                        messageTypes.map(type => {
                            const targetMessageData = messageData[type];
                            const contentData = targetMessageData?.data || [];
                            return {
                                name: <Badge
                                    key={type}
                                    overlap="rectangular"
                                    badgeContent={targetMessageData.unread_count > 99 ? '99+' : (targetMessageData.unread_count || 0)}
                                    max={999}
                                    color="error"
                                    style={{ margin: "0 1rem", cursor: "pointer" }}>
                                    <span style={{ paddingRight: "10px" }}>{type}</span>
                                </Badge>,
                                content:
                                    <Box key={`${type}-content`}>
                                        {/**目前只有公佈欄需要 */
                                            type === HintType.BULLTIN && <Box>
                                                <Box display="flex" alignItems="center" p={1}>
                                                    <Box flex={1}>
                                                        <MessageParamsChips type={type} searchParams={messageSearch[type]} onDelete={handleChipDelete} />
                                                    </Box>
                                                    <ReactIconBtn /* tiptitle="進階搜尋篩選條件" */ click={() => { setModalOpen(ModalName.SEARCH_SETTINGS, type) }} color="primary" icon={<MenuOpen />} />
                                                </Box>
                                                <Divider />
                                            </Box>
                                        }
                                        {contentData.length > 0 ?
                                            <Box >
                                                {contentData.map((elem, index) => {
                                                    let id: string = ''
                                                    if (type === HintType.BULLTIN) {
                                                        id = (elem as BulletinSearchResItemBulletin).bulletin_id;
                                                    } else {
                                                        id = (elem as HintBellLogSearchResItemHintbell).json;
                                                    }

                                                    return (<>
                                                        <Accordion
                                                            key={`${type}-item-${index}`}
                                                            square
                                                            expanded={false}
                                                            id={id}
                                                            //name={elem.sps_remark}
                                                            onClick={() => handleAccordionClick(id, elem, type)}
                                                        >
                                                            <AccordionContent
                                                                expanded={expandedContent === id}
                                                                type={type}
                                                                data={elem}
                                                                index={index}
                                                                bulletinfileList={bulletinfileList}
                                                                handleLinkClick={handleLinkClick}
                                                            />
                                                        </Accordion></>)
                                                })}
                                                <PaginationActionsTS
                                                    totalPage={messageData[type]?.totalPage}
                                                    page={messageSearch[type].page}
                                                    onPageChange={(_, nowPage) => handleChangePage(nowPage, type)}
                                                />
                                            </Box>
                                            : <NoResults title="查無通知" />
                                        }
                                    </Box>
                            }
                        })}
                    disableRipple={true}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    ariaLabel={"scrollable auto tabs"}
                />
        }} />
        {
            modalState[ModalName.SEARCH_SETTINGS] &&
            <SearchSettings
                hintType={modalState[ModalName.SEARCH_SETTINGS]}
                searchOptions={modalState[ModalName.SEARCH_SETTINGS] ? messageSearch[modalState[ModalName.SEARCH_SETTINGS]] : {}}
                searchSettingsModalConfirm={searchSettingsModalConfirm}
                modalClose={() => setModalOpen(ModalName.SEARCH_SETTINGS, false)}
            />
        }
    </>)
}

interface MessageParamsChipsProps {
    type: HintType,
    searchParams: MessageSearch[HintType],
    onDelete: (key: string, type: HintType) => void,
}

const MessageParamsChips = (props: MessageParamsChipsProps) => {

    const classes = useStyles();
    const { searchParams, onDelete, type } = props;
    return (
        <Box display="flex" flexWrap="wrap" pl={1}>
            {Object.entries(searchParams).map(([key, value]) => {
                const messageSetting = messageSearchFields[key as keyof typeof messageSearchFields];
                if (value && messageSetting) {
                    return (
                        <Chip
                            key={`${type}-chip-${key}`}
                            variant="outlined"
                            size="small"
                            clickable={false}
                            label={`${messageSetting.title}: ${messageSetting.fieldtype === "date" ? new CustomDate(value).toYYYYMMDD("/") : value}`}
                            style={{ marginRight: "8px" }}
                            onDelete={() => {
                                onDelete(key, type);
                            }}
                            classes={{
                                outlined: classes.outlined
                            }}
                        />
                    );
                }
            })}
        </Box>
    );
};

interface AccordionContentProps {
    expanded: boolean; // 是否展開
    bulletinfileList: { [key: string]: SearchFileResItem[] }, // 公佈欄檔案列表
    type: HintType;
    data: BulletinSearchResItemBulletin | HintBellLogSearchResItemHintbell;
    index: number;
    handleLinkClick: (elem: HintBellLogSearchResItemHintbell) => void;
}

const AccordionContent = (props: AccordionContentProps) => {
    const { expanded, bulletinfileList, type, data, index, handleLinkClick } = props;

    switch (type) {
        case HintType.PDI:
            const PDIElem = data as HintBellLogSearchResItemHintbell;
            let info_json = PDIElem.info_json !== "" ? JSON.parse(PDIElem.info_json) : "";
            let contract_name = info_json !== "" ? info_json.contract_name : ""; // 客戶姓名
            let car_type = info_json !== "" ? info_json.car_type : "";           // 車型
            return (<AccordionSummary aria-controls="panel1d-content" id="panel1d-header"
                style={{
                    opacity: PDIElem.is_read === 'Y' ? '50%' : '100%',
                    overflow: "hidden"
                }}>
                <Grid item lg={12} md={12} xs={12}>
                    <Grid container style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                        <Grid item lg={12} md={12} xs={12}>
                            <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{`${index + 1}.  ${PDIElem.sps_name}`}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container style={{ display: "flex", alignItems: "center" }}>
                        <Grid item lg={3} md={3} xs={12}>
                            <Typography style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354" }}>{`說明:  ${PDIElem.title}${PDIElem.status}`}</Typography>
                        </Grid>
                        <Grid item lg={2} md={2} xs={12}>
                            <Typography style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354" }}>{`客戶姓名:  ${contract_name}`}</Typography>
                        </Grid>
                        <Grid item lg={2} md={2} xs={12}>
                            <Typography style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354" }}>{`車型:  ${car_type}`}</Typography>
                        </Grid>
                        <Grid item lg={2} md={2} xs={12}>
                            <Typography style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{`建立人:  ${PDIElem.apply_name}`}</Typography>
                        </Grid>
                        <Grid item lg={3} md={3} xs={12}>
                            <Typography style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354" }}>{`建立時間:   ${new CustomDate(PDIElem.cre_time).toCustomFormat('MM/dd HH:mm')}`}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <ReactIconBtn
                    color="primary"
                    click={() => handleLinkClick(PDIElem)}
                    icon={<OpenInNewOutlined />} />
            </AccordionSummary>);
        case HintType.BULLTIN:
            const bulltinElem = data as BulletinSearchResItemBulletin;
            const fileList = bulletinfileList[bulltinElem.bulletin_id] || [];
            return <Accordion
                square={false}
                expanded={expanded}>
                <AccordionSummary
                    aria-controls={bulltinElem.bulletin_id + "-content"}
                    style={{
                        opacity: bulltinElem.is_read === 'Y' ? '50%' : '100%',
                        overflow: "hidden"
                    }}
                    id={bulltinElem.bulletin_id + "-header"}
                    expandIcon={<ExpandMoreRounded />}>
                    <Box fontSize="1.1rem">
                        {`${index + 1}.  ${bulltinElem.subject}`}
                    </Box>
                </AccordionSummary>
                {expanded &&
                    <AccordionDetails style={{ overflowWrap: "anywhere", display: "block" }}>
                        <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>內容:</Typography>
                        <div style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354" }} dangerouslySetInnerHTML={{ __html: bulltinElem.content }}>
                        </div>
                        {
                            fileList.length > 0 && <>
                                <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>附件檔案:</Typography>
                                <MultiFileUpload
                                    max={6}
                                    maxSize={5 * 1024 * 1024}
                                    mode={["preview"]}
                                    data={fileList.map(item => {
                                        return {
                                            id: item.file_id,
                                            name: item.filename,
                                            src: linkURL + item.path,
                                            path: linkURL + item.path
                                        }
                                    })}
                                />
                            </>
                        }
                    </AccordionDetails>}
            </Accordion>;
        default:
            const messageElem = data as HintBellLogSearchResItemHintbell;
            return (<AccordionSummary aria-controls="panel1d-content" id="panel1d-header" style={{
                opacity: messageElem.is_read === 'Y' ? '50%' : '100%'
            }}>
                <Grid item lg={12} md={12} xs={12}>
                    <Grid container style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                        <Grid item lg={12} md={12} xs={12}>
                            <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{`${index + 1}.  ${messageElem.sps_name}`}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container style={{ display: "flex", alignItems: "center" }}>
                        <Grid item lg={4} md={4} xs={12}>
                            <Typography style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354" }}>{`說明: ${messageElem.title}-${messageElem.status}`}</Typography>
                        </Grid>
                        <Grid item lg={4} md={4} xs={12}>
                            <Typography style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{`建立人: ${messageElem.apply_name}`}</Typography>
                        </Grid>
                        <Grid item lg={4} md={4} xs={12}>
                            <Typography style={{ marginLeft: "16px", fontSize: "0.8rem", color: "#4e5354" }}>{`建立時間: ${new CustomDate(messageElem.cre_time).toYYYYMMDDHHMMSS('-', ' ', ':')}`}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <ReactIconBtn
                    color="primary"
                    click={() => handleLinkClick(messageElem)}
                    icon={<OpenInNewOutlined />} />
            </AccordionSummary>);
    }
}

export default ModalHintBell;